import styled from "styled-components";

export const StyledImageDetail = styled.div<{ round: boolean }>`
  width: 12px;
  height: 12px;
  position: relative;
  display: flex;
  align-items: center;
  ${({ round }) => round && `border-radius: 50%`};
  overflow: hidden;
`;
